<div class="grid" *ngIf="notificationsData">
  <div class="grid__box grid__box--size-min">
    <app-topbar-notifications-popover
      [priority]="'high'"
      [notifications]="notificationsData && notificationsData.critical.grouped_notifications"
      [count]="notificationsData && notificationsData.critical.count"
    ></app-topbar-notifications-popover>
  </div>
  <div class="grid__box grid__box--size-min">
    <app-topbar-notifications-popover
      [priority]="'optional'"
      [notifications]="notificationsData && notificationsData.other.grouped_notifications"
      [count]="notificationsData && notificationsData.other.count"
    ></app-topbar-notifications-popover>
  </div>
</div>
